// extracted by mini-css-extract-plugin
export default {"reviewVideoMenu":"qcagent-submitted-videos-pending_reviewVideoMenu__pm1Um","reviewVideoTabMain":"qcagent-submitted-videos-pending_reviewVideoTabMain__myPbT"};